import React from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRulerTriangle} from "@fortawesome/pro-light-svg-icons/faRulerTriangle";

const Units = (props) => {

    return (
        <>
            {props.units.map(unit =>
                <div key={unit.id} className="mb-2">
                    <h2 className="kenmerkenTitel">{unit.name}</h2>
                    <div className="row">
                        <div className="col-sm-5">
                            <div className="rounded"
                                  style={{
                                      backgroundImage: unit.images?.[0]?.url
                                          ? `url(${unit.images[0].url})`
                                          : '',
                                      backgroundSize: 'cover',
                                      backgroundPosition: 'center',
                                      aspectRatio: '5 / 3',
                                      marginLeft: 'auto',
                                      marginRight: 'auto',
                                  }}>
                            </div>
                        </div>
                        <div className="col-sm-7">
                            {!!unit.rental_status &&
                                <div className="mb-3 mt-2 mt-md-0">
                                    <div
                                        className={`badge ${unit.raw_rental_status === "available" ? "badge-success" : "badge-info"} text-lowercase`}
                                        style={{ fontSize: "11px", padding: "7px" }}
                                    >
                                        {unit.rental_status}
                                    </div>
                                </div>
                            }
                            {!!unit.full_rental_price &&
                                <div className="h5">{unit.full_rental_price}</div>
                            }
                            <div className="mb-3 mt-2 mt-md-0">{unit.full_address}</div>
                            <div className="h6"><FontAwesomeIcon icon={faRulerTriangle} size="lg" className="mr-1" /> {unit.surface_formatted}</div>
                            <div className="h6 mt-3">
                                {unit.subtypes && unit.subtypes.length > 0 &&
                                    unit.subtypes.map((subtype, index) => (
                                        <span
                                            key={index}
                                            className="badge badge-light mr-1"
                                        >
                                            {subtype}
                                        </span>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )

}

export default HeaderFooterHOC(Units, 'units');
